export default "__VITE_ASSET__DFvyhUNj__"